<div class="options-container" id="div_options-container_31bee355">
  <!--PAGE TITLE-->
  <div class="title" id="div_title_c9009ec4">Selections</div>
  <div
    class="text-secondary mb-4 d-flex norm-text"
    id="div_text-secondary_08f19baa"
  >
    <span id="span_c1dd1066"
      >Please review your selected railcars. Want to make different selections?
      <button
        type="button"
        class="btn btn-link"
        (click)="showBackModal()"
        id="button_btn_6d5478cc"
      >
        Return to search.
      </button>
    </span>
  </div>
  <!--PARAGRAPH-->
  <div
    class="container-fluid your-sections p-0"
    id="div_container-fluid_a659fa5d"
  >
    <div
      class="selected-cars"
      *ngIf="selectedCars.length > 0; else no_car_selected"
      id="div_selected-cars_d43cea89"
    >
      <div
        class="card"
        *ngFor="let carDetails of selectedCars"
        id="div_card_e8aa36ca"
      >
        <app-quick-view-card
          [displayHead]="false"
          [displayClear]="true"
          [carDetails]="carDetails"
          [displayedAttr]="cardAttrList"
          (cardToggled)="cardRemoved($event)"
        ></app-quick-view-card>
      </div>
    </div>
    <ng-template #no_car_selected="" id="ng-template_828333e9">
      <div class="no-railcars-wrapper" id="div_no-railcars-wrapper_7741654e">
        <div class="no-railcars-header" id="div_no-railcars-header_4cb7a2fa">
          Railcars (0)
        </div>
        <div class="no-railcars-body" id="div_no-railcars-body_1ffc7c49">
          No railcars were selected. Please continue to mechanical options to
          submit your quote request.
        </div>
      </div>
    </ng-template>

    <!--PLACEHOLDER BUTTONS-->
    <div class="button-container" id="div_button-container_126ad960">
      <button
        icon="pi pi-arrow-left"
        (click)="showBackModal()"
        class="back-button"
        pButton=""
        label="Previous"
        id="button_back-button_fcaebec5"
      ></button>

      <button
        class="quiz-button"
        styleClass="p-button-next"
        (click)="next()"
        icon="pi pi-arrow-right"
        pButton=""
        label="Next"
        id="button_quiz-button_bde37f45"
      ></button>
    </div>
  </div>
</div>

<!-- Modal -->
<p-dialog
  #returnSearch=""
  [(visible)]="displayReturnToSearch"
  [modal]="true"
  [style]="{ width: '524px', height: '390px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_316e2978"
>
  <div class="m-title" id="div_m-title_deb3ac12">
    Are you sure you want to return to your search?
  </div>
  <p id="p_2651cb02">
    If you change your railcar type or product, any mechanical or lease options
    you may have entered will be cleared.
  </p>
  <button
    class="return-search"
    (click)="navigateHome()"
    id="button_return-search_d858c2c0"
  >
    Yes, return to search.
  </button>
</p-dialog>
